<template>
  <model-form
    ref="modelForm"
    :model="modifierSet"
  >
    <div class="column">
      <div class="row q-col-gutter-sm items-center">
        <model-form-input
          field="name"
          class="col-10"
          label="Name"
          :rules="[val => !$_.isEmpty(val) || 'Field is required']"
          autofocus
        />
        <model-form-checkbox
          field="printingOptions.print_name"
          value-type="Boolean"
          class="col-2 q-pb-md"
          label="Print Name"
        >
          <q-tooltip>
            Prints the modifier set name along with the modifier name on prep slips.
          </q-tooltip>
        </model-form-checkbox>
      </div>
      <div class="row q-col-gutter-sm items-center">
        <sales-channel-select
          :model="modifierSet"
          class="col-12"
          :channels="SALES_CHANNEL_TYPES.MENU"
        />
        <model-form-checkbox
          field="multiselect"
          class="col-3 q-pb-md"
          label="Select Multiple"
        >
          <q-tooltip>
            Allow customers to select multiple modifiers from this set on a single item.
          </q-tooltip>
        </model-form-checkbox>
      </div>
      <modifier-set-modifier-table
        :modifier-set="modifierSet"
      />
    </div>
  </model-form>
</template>

<script>

import { TYPES as SALES_CHANNEL_TYPES } from 'src/models/model/concerns/SalesChannelRestrictable'
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'
import SalesChannelSelect from 'src/modules/admin/components/SalesChannelSelect'
import ModifierSetModifierTable from 'src/modules/admin/modifier-set/ModifierSetModifierTable'

export default {
  name: 'ModifierSetForm',
  components: {
    ModelForm,
    ModifierSetModifierTable,
    SalesChannelSelect
  },
  models: {
    modifierSet: {
      modifiers: {
        modifierSets: {
          fields: ['id', 'name']
        },
        disableEditCostCents: true,
        inventoryAvailabilitiesAndConstraintsByLocationAndRegisterStation: true,
        inventoryRecipes: 'default',
        locations: 'default',
        libraryParentId: true,
        receiveLibraryUpdates: true
      },
      editing: true,
      libraryChildSiteIds: true
    }
  },
  created () {
    _.extend(this, { SALES_CHANNEL_TYPES })
  }
}

</script>
